import axiosClient from '../lib/api/axiosClient';
import { LoginInput, RegisterInput, AuthResponse } from '../models/User';

class AuthServiceError extends Error {
    statusCode: number;
    
    constructor(message: string, statusCode: number) {
        super(message);
        this.statusCode = statusCode;
        this.name = 'AuthServiceError';
    }
}

export const authService = {
    getAccessToken(): string | null {
        return localStorage.getItem('accessToken');
    },

    getRefreshToken(): string | null {
        return localStorage.getItem('refreshToken');
    },

    setTokens(accessToken: string, refreshToken: string): void {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
    },

    clearTokens(): void {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    },

    async login(credentials: LoginInput): Promise<AuthResponse> {
        try {
            const { data } = await axiosClient.post<AuthResponse>('/Login', {
                Email: credentials.Email,
                Password: credentials.Password
            });
            
            this.setTokens(data.AccessToken, data.RefreshToken);
            return data;
        } catch (error: any) {
            throw new AuthServiceError(
                error.response?.data?.message || 'Failed to login',
                error.response?.status || 500
            );
        }
    },

    async register(userData: RegisterInput): Promise<AuthResponse> {
        try {
            const { data } = await axiosClient.post<AuthResponse>('/Register', {
                Email: userData.Email,
                Password: userData.Password,
                Name: userData.Name
            });
            
            this.setTokens(data.AccessToken, data.RefreshToken);
            return data;
        } catch (error: any) {
            throw new AuthServiceError(
                error.response?.data?.message || 'Failed to register',
                error.response?.status || 500
            );
        }
    },

    async refreshToken(): Promise<AuthResponse> {
        try {
            const refreshToken = this.getRefreshToken();
            const { data } = await axiosClient.post<AuthResponse>('/RefreshToken', { 
                RefreshToken: refreshToken 
            });
            
            this.setTokens(data.AccessToken, data.RefreshToken);
            return data;
        } catch (error: any) {
            this.clearTokens();
            throw new AuthServiceError(
                error.response?.data?.message || 'Failed to refresh token',
                error.response?.status || 500
            );
        }
    },

    async logout(): Promise<void> {
        this.clearTokens();
    }
}; 